 (function () {
     var s = document.createElement('script');
     s.src = 'https://cdn-prod.securiti.ai/consent/cookie-consent-sdk-loader.js';
     s.setAttribute('data-tenant-uuid', 'fd53fe1a-5b15-4602-bbff-18182d3c91d2');
     s.setAttribute('data-domain-uuid', 'c90cd3a7-9e86-4227-8cba-fc27d4bb3ed2');
     s.setAttribute('data-backend-url', 'https://app.securiti.ai');
     s.setAttribute('data-skip-css', 'false');
     s.defer = true;
     var parent_node = document.head || document.body;
     parent_node.appendChild(s);

     s.onload = function() {
         setConsentBannerParams({
             uuid: null
         });
     }

})()